import { Component, inject, OnInit, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../services/auth.service";
import { NotificationService } from "../../services/notification.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;

  slides = [
    { image: "assets/images/news1.png", text: "Explore Legal and Public Announcements From Government" },
    { image: "assets/images/news2.png", text: "Explore Your Digital Source of Government Information" },
  ];

  currentIndex = 0;
  interval: any;

  private fb: FormBuilder = inject(FormBuilder);
  private authService: AuthService = inject(AuthService);
  private notificationService: NotificationService = inject(NotificationService);
  private router: Router = inject(Router);

  form: FormGroup;
  loading = false;

  constructor() { }

  ngOnInit() {
    this.form = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required],
    }, { validator: this.passwordsMatchValidator });

    this.interval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    }, 3000);
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  // Custom validator to check newPassword === confirmPassword
  private passwordsMatchValidator(group: FormGroup) {
    const newPassword = group.get('newPassword')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return newPassword === confirmPassword ? null : { passwordsMismatch: true };
  }

  // Function to submit reset password
  async resetPassword() {
    if (this.form.invalid) {
      if (this.form.hasError('passwordsMismatch')) {
        this.notificationService.errorSnackbar("Passwords do not match");
      } else {
        this.notificationService.errorSnackbar("Please fill all fields correctly");
      }
      return;
    }

    this.loading = true;

    const formData = {
      newPassword: this.form.value.newPassworda
    };

    try {
      const response = await this.authService.resetPassword(formData);
      this.notificationService.successSnackbar("Password changed successfully");
      
      // Optional: Redirect after successful password reset
      setTimeout(() => {
        this.router.navigate(['/dashboard']);
      }, 1500);

    } catch (error: any) {
      console.error("Reset password error:", error);
      this.notificationService.errorSnackbar(
        error?.error?.message || 
        error?.message || 
        "An error occurred while resetting password"
      );
    } finally {
      this.loading = false;
    }
  }

  toggleShowPassword(field: string) {
    if (field === 'new') this.showPassword = !this.showPassword;
    if (field === 'confirm') this.showConfirmPassword = !this.showConfirmPassword;
  }

  prev() {
    this.currentIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
  }

  // Getter for easy form access in template
  get newPassword() {
    return this.form.get('newPassword');
  }

  get confirmPassword() {
    return this.form.get('confirmPassword');
  }
}